/*
--------------------------------------------------------------------------------
----------------------------> CUSTOMER SECTION <-------------------------------
--------------------------------------------------------------------------------
*/


CR.customerPage = function() {
  // Initialize observers on address selectors
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });

  // Setup province selector on each customer address
  // {% for address in customer.addresses %}
  //   new Shopify.CountryProvinceSelector('AddressCountry_{{address.id}}', 'AddressProvince_{{address.id}}', {
  //     hideElement: 'AddressProvinceContainer_{{address.id}}'}
  //   );
  // {% endfor %}

  // Setup province selector on each customer address (Liquid-free version)
  var $edit_address = $('.edit_address');
  $edit_address.each(function(i, a) {
    var address_id = a.id.replace(/\D/g,'');
    new Shopify.CountryProvinceSelector('AddressCountry_' + address_id, 'AddressProvince_' + address_id, {
      hideElement: 'AddressProvinceContainer_' + address_id}
    );
  });

  // Preselect UK for new addresses
  document.getElementById('AddressCountryNew').value = 'United Kingdom';

  // Modified contents of customer_area.js (global asset)
  Shopify.CustomerAddress = {
    toggleForm: function(id) {
      var editEl = document.getElementById('EditAddress_'+id);
      editEl.style.display = editEl.style.display == 'none' ? '' : 'none';
      var staticEl = document.getElementById('StaticAddresses');
      staticEl.style.display = staticEl.style.display == 'none' ? '' : 'none';
      return false;
    },

    toggleNewForm: function() {
      var aa = document.getElementById('add_address_form');
      aa.style.display = aa.style.display == 'none' ? '' : 'none';
      var aaB = document.getElementById('add_address');
      aaB.style.display = aaB.style.display == 'none' ? '' : 'none';
      return false;
    },

    destroy: function(id, confirm_msg) {
      if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
        Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
      }
    }
  }
}


// Init on docready
CR.initCustomerPage = function () {
  CR.customerPage();
}

$(CR.initCustomerPage);
